module.exports = __webpack_public_path__ + "img/app_icon1.ac77f777.png";